module.exports = __webpack_public_path__ + "img/MY.8d6bd32e.svg";